/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2020, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const OPEN_PREVIEW_DEBUG_MODE = 'OPEN_PREVIEW_DEBUG_MODE';
export const CLOSE_PREVIEW_DEBUG_MODE = 'CLOSE_PREVIEW_DEBUG_MODE';

export const ADD_SYS_NUMBER_AS_SUPPORTING_ENTITY =
  'ADD_SYS_NUMBER_AS_SUPPORTING_ENTITY';
export const RESET_ACTIONS_STATE = 'RESET_ACTIONS_STATE';

export const LOAD_CURRENT_ACTION = 'LOAD_CURRENT_ACTION';
export const SET_CURRENT_ACTION_ID = 'SET_CURRENT_ACTION_ID';

export const LIST_ACTIONS_START = 'LIST_ACTIONS_START';
export const LIST_ACTIONS_SUCCESS = 'LIST_ACTIONS_SUCCESS';
export const LIST_ACTIONS_ERROR = 'LIST_ACTIONS_ERROR';

export const GET_ACTION_START = 'GET_ACTION_START';
export const GET_ACTION_SUCCESS = 'GET_ACTION_SUCCESS';
export const GET_ACTION_ERROR = 'GET_ACTION_ERROR';

export const GET_SUB_ACTION_START = 'GET_SUB_ACTION_START';
export const GET_SUB_ACTION_SUCCESS = 'GET_SUB_ACTION_SUCCESS';
export const GET_SUB_ACTION_ERROR = 'GET_SUB_ACTION_ERROR';

export const CREATE_EMPTY_ACTION = 'CREATE_EMPTY_ACTION';
export const CREATE_EMPTY_ACTION_START = 'CREATE_EMPTY_ACTION_START';

export const CREATE_ACTION_SUCCESS = 'CREATE_ACTION_SUCCESS';
export const CREATE_ACTION_ERROR = 'CREATE_ACTION_ERROR';

export const DELETE_ACTION_START = 'DELETE_ACTION_START';
export const DELETE_ACTION_SUCCESS = 'DELETE_ACTION_SUCCESS';
export const DELETE_ACTION_ERROR = 'DELETE_ACTION_ERROR';

export const SAVE_CURRENT_ACTION_START = 'SAVE_CURRENT_ACTION_START';
export const SAVE_CURRENT_ACTION_SUCCESS = 'SAVE_CURRENT_ACTION_SUCCESS';
export const SAVE_CURRENT_ACTION_ERROR = 'SAVE_CURRENT_ACTION_ERROR';
export const SAVE_CURRENT_ACTION_CONFLICT_ERROR =
  'SAVE_CURRENT_ACTION_CONFLICT_ERROR';
export const CLEAR_CURRENT_ACTION_CONFLICT_ERROR =
  'CLEAR_CURRENT_ACTION_CONFLICT_ERROR';

export const RENAME_ACTION_START = 'RENAME_ACTION_START';
export const RENAME_ACTION_SUCCESS = 'RENAME_ACTION_SUCCESS';
export const RENAME_ACTION_ERROR = 'RENAME_ACTION_ERROR';

export const CLEAR_ACTION_START = 'CLEAR_ACTION_START';
export const CLEAR_ACTION_SUCCESS = 'CLEAR_ACTION_SUCCESS';
export const CLEAR_ACTION_ERROR = 'CLEAR_ACTION_ERROR';

export const OPEN_CONVO_ACTION_PANEL = 'OPEN_CONVO_ACTION_PANEL';
export const HIDE_CONVO_ACTION_PANEL = 'HIDE_CONVO_ACTION_PANEL';
export const CLEAR_CONVO_ACTION_EDIT_ID = 'CLEAR_CONVO_ACTION_EDIT_ID';

export const UPDATE_CURRENT_VAR_ENTITY = 'EXPORT_CURRENT_VAR_ENTITY';

export const GET_RELATED_INTENT_SUCCESS = 'GET_RELATED_INTENT_SUCCESS';
export const GET_RELATED_INTENT_ERROR = 'GET_RELATED_INTENT_ERROR';

export const UPDATE_INTENT_EXAMPLE = 'UPDATE_INTENT_EXAMPLE';
export const DELETE_INTENT_EXAMPLE = 'DELETE_INTENT_EXAMPLE';
export const CREATE_INTENT_EXAMPLE = 'CREATE_INTENT_EXAMPLE';
export const UPDATE_RELATED_INTENT_SUCCESS = 'UPDATE_RELATED_INTENT_SUCCESS';

export const GET_COUNTER_EXAMPLE_SUCCESS = 'GET_COUNTER_EXAMPLE_SUCCESS';
export const CREATE_COUNTER_EXAMPLE = 'CREATE_COUNTER_EXAMPLE';
export const UPDATE_COUNTER_EXAMPLE = 'UPDATE_COUNTER_EXAMPLE';
export const DELETE_COUNTER_EXAMPLE = 'DELETE_COUNTER_EXAMPLE';

export const SELECT_STEP = 'SELECT_STEP';

export const UPDATE_DIRTY_STATE = 'UPDATE_DIRTY_STATE';
export const UPDATE_AUTO_SAVE = 'action_auto_save';

export const UPDATE_ACTION_DESCRIPTION_START =
  'UPDATE_ACTION_DESCRIPTION_START';
export const UPDATE_ACTION_DESCRIPTION_SUCCESS =
  'UPDATE_ACTION_DESCRIPTION_SUCCESS';
export const UPDATE_ACTION_DESCRIPTION_ERROR =
  'UPDATE_ACTION_DESCRIPTION_ERROR';

export const UPDATE_ACTION_DISAMBIGUATION_START =
  'UPDATE_ACTION_DISAMBIGUATION_START';
export const UPDATE_ACTION_DISAMBIGUATION_SUCCESS =
  'UPDATE_ACTION_DISAMBIGUATION_SUCCESS';
export const UPDATE_ACTION_DISAMBIGUATION_ERROR =
  'UPDATE_ACTION_DISAMBIGUATION_ERROR';

export const UPDATE_ACTION_TOPIC_SWITCH_START =
  'UPDATE_ACTION_TOPIC_SWITCH_START';
export const UPDATE_ACTION_TOPIC_SWITCH_SUCCESS =
  'UPDATE_ACTION_TOPIC_SWITCH_SUCCESS';
export const UPDATE_ACTION_TOPIC_SWITCH_ERROR =
  'UPDATE_ACTION_TOPIC_SWITCH_ERROR';

export const ADD_LAUNCH_MODE = 'ADD_LAUNCH_MODE';

export const DUPLICATE_STEP_ENTITY = 'DUPLICATE_STEP_ENTITY';

export const SET_DANGER_WORD_VALUES = 'SET_DANGER_WORD_VALUES';
export const SET_PROFANE_WORD_VALUES = 'SET_PROFANE_WORD_VALUES';
export const SET_STEP_MAX_HITS = 'SET_STEP_MAX_HITS';

export const SET_EDITOR_CONTEXT = 'SET_EDITOR_CONTEXT';

export const GLOBAL_SETTINGS_REDIRECT_START = 'GLOBAL_SETTINGS_REDIRECT_START';
export const GLOBAL_SETTINGS_REDIRECT_SUCCESS =
  'GLOBAL_SETTINGS_REDIRECT_SUCCESS';

// For AI Guided Action
export const SET_KNOWLEDGE_CONTENT = 'SET_KNOWLEDGE_CONTENT';
export const SET_PROMPT_INSTRUCTION = 'SET_PROMPT_INSTRUCTION';
export const SET_MODEL_SELECTION = 'SET_MODEL_SELECTION';
export const SET_AI_GUIDED = 'SET_AI_GUIDED';
export const SET_IS_AI_GUIDED_ACTION = 'SET_IS_AI_GUIDED_ACTION';
